import { render } from "./BookingTocPage.vue?vue&type=template&id=10a1cf18&scoped=true"
import script from "./BookingTocPage.vue?vue&type=script&lang=js"
export * from "./BookingTocPage.vue?vue&type=script&lang=js"

import "./BookingTocPage.vue?vue&type=style&index=0&id=10a1cf18&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10a1cf18"
/* hot reload */
if (module.hot) {
  script.__hmrId = "10a1cf18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10a1cf18', script)) {
    api.reload('10a1cf18', script)
  }
  
  module.hot.accept("./BookingTocPage.vue?vue&type=template&id=10a1cf18&scoped=true", () => {
    api.rerender('10a1cf18', render)
  })

}

script.__file = "src/views/BookingTocPage.vue"

export default script